//Global variables
var position;
var infoWindow;
var infoWindowContent = [];
var map;
var markerItems = [];
var _searchedLocation = null;

// Get the current location of the user from the browser
function getCurrentLocation() {
    var options = {
        enableHighAccuracy: true,
        timeout: 5000,
        maximumAge: 0
    };
    navigator.geolocation.getCurrentPosition(getCurrentLocation_success, getMapFromCountry, options);
}

// Handle results from getting the current location.
function getCurrentLocation_success(pos) {
    position = pos;
    var location;
    if (position != null) {
        location = new google.maps.LatLng(position.coords.latitude, position.coords.longitude);
        var geocoder = new google.maps.Geocoder;
        var latlng = { lat: position.coords.latitude, lng: position.coords.longitude };
        geocoder.geocode({ 'location': latlng }, function (results, status) {
            if (status === google.maps.GeocoderStatus.OK) {
                if (results[0]) {
                    var address = results[0].address_components;
                    if (address) {
                        var zip = $.grep(address, function (e) { return e.types[0] == 'postal_code'; });
                        if (zip && $('#zipCode').is(":visible") && $('#zipCode').val() == '') {
                            $('#zipCode').val(zip[0].long_name);
                        }
                    }
                } else {
                    if (window.console) console.log('No results found');
                }
            } else {
                if (window.console) console.log('Geocoder failed due to: ' + status);
            }
        });
    } else {
        location = new google.maps.LatLng(44.970697, -93.2614785);
    }
    var varMapoptions = {
        center: location,
        zoom: 14
    };
    var varMap = new google.maps.Map(document.getElementById("map-canvas"),
        varMapoptions);
};

// Display the google map based on the current country code.
function getMapFromCountry() {
    var countryCode = "";
    $("#country-selector option:selected").length > 0 && (countryCode = $("#country-selector option:selected").attr("data-country-internal-name"));
    if (countryCode != null || countryCode != '') {
        var pathArray = window.location.pathname.split('/');
        var language = pathArray[0].length > 0 ? pathArray[0] : pathArray[1];
        if (language.length == 5 && language.slice(language.indexOf('-') + 1, 5).toUpperCase() == "NL") {
            countryCode = 'Netherlands';
        }
        //else {
        //    countryCode = "United States";
        //}
        if ($("#country-selector option:selected").length > 0 && $("#country-selector option:selected").attr("data-country-code").toUpperCase() == "NL"){
            countryCode = 'Netherlands';
        }
    }
    var n, i, t;
    n = new google.maps.Geocoder;
    n.geocode({
            address: countryCode
    }, function (n, r) {
        var location;
            if (r === google.maps.GeocoderStatus.OK) {
                location = n[0].geometry.location;
            }
            var varMapoptions = {
                center: location,
                zoom: 4
            };
            var varMap = new google.maps.Map(document.getElementById("map-canvas"),
                varMapoptions);
        }
    );
}

function getSearchedLocation() {
    var address = '';
    var zipCode = $('#zipCode');
    if (zipCode != null && zipCode.val() != '') {
        address = zipCode.val();
    }
    var country = $("#country-selector option:selected");
    if (country != null && country.length > 0) {
        address += ' ' + country.attr("data-country-code");
    }
    if (address != '') {
        var searchedLat = Toro.locatorResultItems().searchedLat;
        var searchedLng = Toro.locatorResultItems().searchedLng;
        var n, i, t;
        n = new google.maps.Geocoder;
        n.geocode({
            address: address
        }, function (n, r) {
            if (r === google.maps.GeocoderStatus.OK) {
                var position = new google.maps.LatLng(searchedLat, searchedLng);
                var marker = new google.maps.marker.AdvancedMarkerElement({
                    position: position,
                    map: map
                });
            }
        });
    }
}

// Support function to check if locator map can be initialized
function canInitializeLocatorMap() {
    return window.google
        && window.google.maps
        && typeof Toro !== 'undefined'
        && typeof Toro.locatorResultItems === 'function'
        && document.getElementById("map-canvas");
}

// Show location from the results returned.
function showLocations() {
    if (canInitializeLocatorMap()) {
        init_locations_map();
    }
}

window.initUniqueLocatorMap = function () {
    if (canInitializeLocatorMap()) {
        init_locations_map();
    }
};


// Initialize the locations map.
async function init_locations_map() {
    if (!canInitializeLocatorMap()) {
        return;
    }
    var bounds = new google.maps.LatLngBounds();
    var markers = [];
    var marker;
    var i;
    var mapOptions = {
        mapTypeId: 'roadmap',
        mapId: 'LOCATOR_MAP'
    };
    // Display a map on the page
    map = new google.maps.Map(document.getElementById("map-canvas"), mapOptions);
    // Display multiple markers on a map
    infoWindow = new google.maps.InfoWindow(), marker, i;
    var locations = Toro.locatorResultItems().locations;
    var directionsButtonLabel = Toro.locatorResultItems().directionsButtonLabel;
    var websiteButtonLabel = Toro.locatorResultItems().websiteButtonLabel;
    var detailsButtonLabel = Toro.locatorResultItems().detailsButtonLabel;
 
    // Loop through each of the markers creating an info window for each one.
    $.each(locations, function (index, v) {
        var location = [v.Name, v.Latitude, v.Longitude];
        markers.push(location);
        var address = '';
        if (v.Address != null) {
            address = (v.Address.AddressLine1 != null ? v.Address.AddressLine1 + '<br />' : '') +
                (v.Address.AddressLine2 != null ? v.Address.AddressLine2 + '<br />' : '') +
                (v.Address.City != null ? v.Address.City + ', ' : '') +
                (v.Address.Region != null ? v.Address.Region + ' ' : '') +
                (v.Address.PostalCode != null ? v.Address.PostalCode + '<br />' : '') +
                (v.Address.Country != null ? v.Address.Country + ' ' : '');
        } else {
            address = (v.AddressLine1 != null ? v.AddressLine1 + '<br />' : '') +
                (v.AddressLine2 != null ? v.AddressLine2 + '<br />' : '') +
                (v.City != null ? v.City + ', ' : '') +
                (v.Region != null ? v.Region + ' ' : '') +
                (v.PostalCode != null ? v.PostalCode + '<br />' : '') +
                (v.Country != null ? v.Country + ' ' : '');
        }
         
        var listIndex = index + 1;
        var info = [
            '<div class="info_content">' +
            '<h3>' + v.Name + '</h3>' +
            '<address>' +
            '<p>' + address + '</p>' +
            (v.Phone != '' && v.Phone != null && v.Phone != 'undefined' ? '<a href=\"tel:' + v.Phone + '\" onclick=\"dataLayer.push({\'event\': \'locatorDealerSelect\', \'channelPartnerID\': \' ' + v.DealerId + '\', \'locatorSelect\': \'Phone\'});"\>' + v.Phone + '</a><br>' : '') +
            (v.Email != '' && v.Email != null && v.Email != 'undefined' ? '<a href=\"mailto:' + v.Email + '\" onclick=\"dataLayer.push({\'event\': \'locatorDealerSelect\', \'channelPartnerID\': \' ' + v.DealerId + '\', \'locatorSelect\': \'Email\'});\">' + v.Email + '</a><br>' : '') + '</address>' +
            (v.MapUrl != '' && v.MapUrl != null && v.MapUrl != 'undefined'
                ? '<a class=\"btn btn-primary\" href=\"' + v.MapUrl + '\" target=\"_blank\" onclick=\"dataLayer.push({\'event\': \'locatorDealerSelect\', \'channelPartnerID\': \' ' + v.DealerId + '\', \'locatorSelect\': \'Google\'});\">' + directionsButtonLabel + '</a>&nbsp;' : '') +
            (v.WebSite != null && v.WebSite != null && v.WebSite != '' && v.WebSite != 'undefined'
                ? '<a class=\"btn btn-primary\" href=\"' + v.WebSite + '\" target=\"_blank\" onclick=\"dataLayer.push({\'event\': \'locatorDealerSelect\', \'channelPartnerID\': \' ' + v.DealerId + '\', \'locatorSelect\': \'Website\'});\">' + websiteButtonLabel + '</a>&nbsp;' : '') +
            ($('#dealerDetails' + listIndex).length > 0
                && Toro.locatorResultItems().dealerBrand.toLowerCase() != "irritrol" && Toro.locatorResultItems().dealerBrand.toLowerCase() != "pope" && Toro.locatorResultItems().dealerBrand.toLowerCase() != "uniquelighting"
                ? '<button type=\"button\" class=\"btn btn-primary\" data-toggle=\"modal\" data-target=\"#dealerDetails' + listIndex + '\" onclick=\"dataLayer.push({\'event\': \'locatorDealerSelect\', \'channelPartnerID\': \' ' + v.DealerId + '\', \'locatorSelect\': \'Details\'});\">' + detailsButtonLabel + '</button>' : '') +
            '</div>'
        ];
        infoWindowContent.push(info);
    });

    const { AdvancedMarkerElement } = await google.maps.importLibrary("marker");
    // Loop through our array of markers & place each one on the map
    var firstChar = "A".charCodeAt(0);
    for (i = 0; i < markers.length; i++) {
        var position = new google.maps.LatLng(markers[i][1], markers[i][2]);
        var letter = String.fromCharCode(firstChar + i);;
        const markerImage = document.createElement("img");
        markerImage.src = "//maps.google.com/mapfiles/marker" + letter + ".png";

        marker = new AdvancedMarkerElement({
            position: position,
            map: map,
            content: markerImage,
            title: markers[i][0]
        });
        markerItems.push(marker);
        bounds.extend(marker.position);

        // Allow each marker to have an info window
        google.maps.event.addListener(marker, 'click', (function (marker, i) {
            return function () {
                infoWindow.setContent(infoWindowContent[i][0]);
                infoWindow.open(map, marker);
            }
        })(marker, i));

        if (markers.length > 1) {
            // Adjust the map zoom level to fit all the markers on the screen.
            map.fitBounds(bounds);
        } else {
            var latLng = new google.maps.LatLng(locations[0].Latitude, locations[0].Longitude);
            map.setCenter(latLng);
            map.setZoom(14);
        }
    }
    getSearchedLocation()
}

$(document).ready(function () {
    // Handles the click event of the pin icon on dealer results
    $(document).on("click", "a.dealer-marker", function () {
        var element = $(this);
        var markerIndex = element.data('markerindex');

        document.getElementById('map-canvas').scrollIntoView();
        infoWindow.setContent(infoWindowContent[markerIndex][0]);
        infoWindow.open(map, markerItems[markerIndex]);
        setTimeout(function () {
            var infoDiv = document.querySelector('.info_content');
            if (infoDiv) {
                var firstAnchor = infoDiv.querySelector('a');
                if (firstAnchor) {
                    firstAnchor.blur();
                }
            }
        }, 50);
    });

    $(document).on("change", "#country-selector", function() {
        getMapFromCountry();
    });

});